import * as Yup from "yup";
import {factToavg} from './factorToAvg'
Yup.addMethod(Yup.string, factToavg.name,factToavg.rule );